<template>
  <div>
    <div class="login-header">
      <h2>{{ t('resetPasswordTitle') }}</h2>
      <button class="close-btn" @click="$emit('back')" :aria-label="t('back')">&times;</button>
    </div>

    <div class="form">
      <input
        v-model="email"
        type="email"
        :placeholder="t('email')"
        autocomplete="username"
        @keyup.enter="submit"
      />

      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
      <div v-if="infoMessage" class="success-message">{{ infoMessage }}</div>

      <button :disabled="!canSubmit || busy" @click="submit">
        {{ t('requestPassword') }}
      </button>

      <a href="#" class="forgot-link" @click.prevent="$emit('back')">{{ t('backToLogin') }}</a>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useI18n } from '../i18n/index.js'

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/

export default defineComponent({
  name: 'ForgotPasswordView',

  props: {
    initialEmail: { type: String, default: '' },
    busy: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
    infoMessage: { type: String, default: '' }
  },

  emits: ['submit', 'back'],

  setup() {
    const { t } = useI18n()
    return { t }
  },

  data() {
    return { email: this.initialEmail || '' }
  },

  computed: {
    canSubmit() {
      return !!this.email && EMAIL_REGEX.test(this.email)
    }
  },

  methods: {
    submit() {
      if (!this.canSubmit || this.busy) return
      this.$emit('submit', this.email)
    }
  }
})
</script>

<style scoped>
.login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.login-header h2 { margin: 0; font-size: 1.25rem; }
.close-btn {
  border: none; background: none; font-size: 24px; cursor: pointer; color: #6b7280;
}
.close-btn:hover { color: #000; }
.form { display: flex; flex-direction: column; gap: 12px; }
input {
  padding: 10px; border-radius: 6px; border: 1px solid #ddd;
  font: inherit; font-size: 16px;
}
button {
  padding: 12px; background: #2563eb; color: white; border: none;
  border-radius: 8px; font: inherit; font-size: 16px; cursor: pointer;
}
button:disabled { background: #c7c9d1; cursor: not-allowed; }
.error-message {
  background: #fef2f2; color: #dc2626; border: 1px solid #fecaca;
  padding: 10px 12px; border-radius: 6px; font-size: 13px;
}
.success-message {
  background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0;
  padding: 10px 12px; border-radius: 6px; font-size: 13px;
}
.forgot-link {
  text-align: center; font-size: 13px; color: #6b7280; text-decoration: none;
}
.forgot-link:hover { color: #2563eb; text-decoration: underline; }
</style>
